import { render, staticRenderFns } from "./Regenerate.vue?vue&type=template&id=5d7c5d8e&lang=pug"
import script from "./Regenerate.vue?vue&type=script&lang=js"
export * from "./Regenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports